import { c as _c } from "react/compiler-runtime";
import { BinIcon } from '@systemeio/ui/icons';
import { CheckBoxSwitcher, FormInput, InputProps } from '@systemeio/ui';
import ItemWrapper from 'modules/stores/store/components/item-wrapper';
import { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { InitFieldsInterface } from '..';
interface StoreFieldProps extends Omit<InputProps, 'id'> {
  isRequired: boolean;
  slug: string;
  onChangeRequired: (value: boolean) => void;
  onDelete: (slug: string) => void;
  initFields?: InitFieldsInterface[];
}
const StoreField: FC<StoreFieldProps> = t0 => {
  const $ = _c(24);
  let initFields;
  let isRequired;
  let onChangeRequired;
  let onDelete;
  let rest;
  let slug;
  if ($[0] !== t0) {
    ({
      isRequired,
      onChangeRequired,
      onDelete,
      slug,
      initFields,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = initFields;
    $[2] = isRequired;
    $[3] = onChangeRequired;
    $[4] = onDelete;
    $[5] = rest;
    $[6] = slug;
  } else {
    initFields = $[1];
    isRequired = $[2];
    onChangeRequired = $[3];
    onDelete = $[4];
    rest = $[5];
    slug = $[6];
  }
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[7] !== initFields || $[8] !== slug) {
    t1 = initFields?.find(initField => initField.slug === slug)?.mandatory ?? false;
    $[7] = initFields;
    $[8] = slug;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const isMandatory = t1;
  let t2;
  if ($[10] !== isMandatory || $[11] !== isRequired || $[12] !== onChangeRequired || $[13] !== onDelete || $[14] !== slug || $[15] !== t) {
    t2 = !isMandatory && <div className="flex items-center gap-3"><CheckBoxSwitcher wrapperClassName="flex-row" label={t("dashboard.store.item.required")} selected={isRequired} onChange={onChangeRequired} /><button onClick={() => onDelete(slug)} className="group"><BinIcon className="group-hover:fill-danger group-focus-visible:fill-danger main-transition-colors h-[20px] w-[20px]" /></button></div>;
    $[10] = isMandatory;
    $[11] = isRequired;
    $[12] = onChangeRequired;
    $[13] = onDelete;
    $[14] = slug;
    $[15] = t;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== isRequired || $[18] !== rest || $[19] !== t2) {
    t3 = <FormInput {...rest} disabled={true} required={isRequired} inputClassName="w-full" className="w-full" addonAfter={t2} />;
    $[17] = isRequired;
    $[18] = rest;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== slug || $[22] !== t3) {
    t4 = <ItemWrapper id={slug} className="items-end" iconClassName="mb-[8.5px]">{t3}</ItemWrapper>;
    $[21] = slug;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
};
export default StoreField;